module.exports = __webpack_public_path__ + "static/media/pt-BR.6d63e192.png";